<template>
	<Row class="flex-align-center flex-justify-space-between">
		<Row v-if="flowData" class="flex-align-center mr-5">
			<FeatureIconsCard class="feature-card-container flex-centerize" :flowData="flowData" />
			<h3 class="reg ml-2 one-row">{{ flowData.title }}</h3>
		</Row>
		<h3 v-if="numOfRuns" class="reg">{{ numOfRuns }}</h3>
	</Row>
</template>
<script>
import FeatureIconsCard from '@/components/Modules/FeatureIconsCard.vue';
export default {
	name: 'AnalyticsTopFeatureItem',
	components: { FeatureIconsCard },
	props: {
		flowData: { type: Object },
		numOfRuns: { type: Number },
	},
};
</script>
<style scoped lang="scss">
.feature-card-container {
	min-width: 50px;
	max-width: 50px;
	height: 25px;
	background: #ffffff;
	box-shadow: 0px 1px 2px #00000029;
	border: 1px solid #dbdee2;
	border-radius: 6px;
	::v-deep {
		.workflow-icon {
			width: 15px !important;
			height: 15px !important;
		}
		.integration-icon {
			width: 15px !important;
			height: 15px !important;
			margin-left: 5px !important;
		}
	}
}
</style>
